import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import './index.scss'

/**
 * @example
 * <Textarea
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Textarea" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   placeholder={<FormattedMessage id="SomePlaceholder" defaultMessage="Some Placeholder" />}
 *   required
 * />
 */
const Textarea = ({ className, ...props }: any) => (
  <Field
    {...props}
    className={cn('form__textarea', className)}
    render={({ formik, ...field }: any) => (
      <textarea {...field} onBlur={formik.handleBlur} onChange={formik.handleChange} />
    )}
  />
)

Textarea.displayName = 'Textarea'

Textarea.propTypes = {
  ...propTypes,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  readOnly: PropTypes.bool,
  value: PropTypes.string
}

Textarea.defaultProps = {
  ...defaultProps,
  placeholder: ''
}

export default Textarea
